module.exports = __webpack_public_path__ + "assets/gif.png";